module.exports = __webpack_public_path__ + "img/operate-1.50b4168c.gif";